import { Routes } from '@angular/router';
import { baseRoutes } from './app.routes.shared';

export const routes: Routes = [...baseRoutes];